import { Typography } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import { useEffect, useState } from "react"
import ReactPannellum, {
  addScene,
  getConfig,
  getCurrentScene,
  loadScene,
  setHfov,
} from "react-pannellum"
import ShopLoader from "reusable/ShopLoader"
import styled from "styled-components"

const StyledPanoramaWrap = styled.div`
  position: absolute;
  inset: 0;
  width: auto;

  .pnlm-container {
    background: #fff !important;
    :focus-visible {
      outline: 3px solid ${(p) => p.theme.colors.red};
      :after {
        // contact from aria-label
        content: "רכיב פנורמה, ניתן לנווט עם חצי המקלדת";
        position: absolute;
        top: 0;
        right: 0;
        padding: 5px;
        background: rgba(255, 255, 255, 0.9);
        color: black;
      }
    }
    .pnlm-panorama-info {
      display: none !important;
    }
    .pnlm-load-box {
      height: 100px;
      visibility: hidden;
      .pnlm-lmsg {
        display: none;
      }
    }
  }

  .psv-loader {
    color: ${(p) => p.theme.colors.mazdaRed};
    border-width: 3px;
    width: 100px;
    height: 100px;
  }
`
const StyledShopLoader = styled(ShopLoader)``

const panoramaConfig = {
  autoLoad: true,
  showControls: false,
  showZoomCtrl: false,
  keyboardZoom: false,
  doubleClickZoom: false,
  mouseZoom: false,
  showFullscreenCtrl: false,
  avoidShowingBackground: true,
  uiText: {
    loadingLabel: "טוען...",
    bylineLabel: "",
  },
}

const Panorama = ({ image }: { image: string }) => {
  const isDesktop = useIsDesktop()

  const [panoramaLoaded, setPanoramaLoaded] = useState(false)

  const [zoomLevel, setZoomLevel] = useState(100)
  const [loading, setLoading] = useState(true)

  // Update some options whenever the initial (or a different) window width is detected
  useEffect(() => {
    if (!panoramaLoaded) return

    const zoom = isDesktop ? 100 : 60

    setZoomLevel(zoom)
    setHfov(zoom)

    // TODO: find better solution
    document
      .getElementById("first")
      ?.setAttribute("aria-labelledby", "panoramaLabel")
  }, [isDesktop, panoramaLoaded])

  // Update the image if the prop is changed and the initial image is loaded, to prevent multiple calls
  useEffect(() => {
    if (!panoramaLoaded) return

    const currentScene = getCurrentScene()
    const { pitch, yaw } = getConfig()

    if (currentScene !== image) {
      addScene(
        image,
        {
          ...panoramaConfig,
          imageSource: `${image}`,
          hfov: zoomLevel,
        },
        () => {
          loadScene(image, pitch, yaw)
        }
      )
    }
  }, [panoramaLoaded, image, zoomLevel])
  useEffect(() => {
    if (!panoramaLoaded) return

    // Set loading to false initially when panorama is loaded
    setLoading(false)

    // Select the load box element
    const loadBox = document.querySelector(".pnlm-load-box")

    if (loadBox) {
      // Create a MutationObserver to watch for changes in the load box's attributes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "style") {
            // Check the display style of the load box
            const display = window.getComputedStyle(loadBox).display
            console.log(display)
            // If the load box is visible, set loading to true, otherwise set it to false
            if (display !== "none") {
              setLoading(true)
            } else {
              setLoading(false)
            }
          }
        })
      })

      // Start observing the load box for attribute changes
      observer.observe(loadBox, { attributes: true })

      // Cleanup the observer when the component is unmounted or dependencies change
      return () => {
        observer.disconnect()
      }
    }
  }, [panoramaLoaded])

  return (
    <StyledPanoramaWrap>
      <Typography variant="srOnly" id="panoramaLabel"></Typography>
      {/* <ErrorBoundary fallback={<Error statusCode={500} />}> */}
      <ReactPannellum
        id="first"
        sceneId={image}
        imageSource={`${image}`}
        config={{
          ...panoramaConfig,
          pitch: -12,
          yaw: -90,
        }}
        style={{
          width: "100%",
          height: "100%",
        }}
        onPanoramaLoaded={() => setPanoramaLoaded(true)}
      />
      {/* </ErrorBoundary> */}
      {loading && <StyledShopLoader />}
    </StyledPanoramaWrap>
  )
}

export default Panorama
